import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./pages/Home/Home";
import DiploMarketingComu from "./pages/DiploMarketingComu/DiploMarketingComu";
import MasterDicDeportiva from "./pages/MasterDicDeportiva/MasterDicDeportiva";
import ProgIntroFinGestDepor from "./pages/ProgIntroFinGestDepor/ProgIntroFinGestDepor";
import WhoWeAre from "./pages/WhoWeAre/WhoWeAre";
import Contact from "./pages/Contact/Contact";
import Thanks from "./pages/Thanks/Thanks";

function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route
          exact
          path="/diplomado-en-marketing-y-comunicacion"
          element={<DiploMarketingComu />}
        />
        <Route
          exact
          path="/master-de-direccion-deportiva"
          element={<MasterDicDeportiva />}
        />
        <Route
          exact
          path="/programa-introductorio-en-finanzas-y-gestion-para-deportistas"
          element={<ProgIntroFinGestDepor />}
        />
        <Route exact path="/quienes-somos" element={<WhoWeAre />} />
        <Route exact path="/contacto" element={<Contact />} />
        <Route exact path="/gracias" element={<Thanks />} />
      </Routes>
    </Router>
  );
}

export default App;
